module.exports = __webpack_public_path__ + "img/优势bg.65307101.png";